module.exports = __webpack_public_path__ + "static/img/img-home-jzg-04.bb63e96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-jzg-04.png
// module id = mOMP
// module chunks = 1